// components/features/clients/ClientRow.tsx
import { Client } from '../../../../types/features/support/Client';
import TableRow from '../../../ui/TableRow';

interface ClientRowProps {
  client: Client;
  onAction: (client: Client) => void;
  onSelect?: (client: Client, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function ClientRow({
  client,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false
}: ClientRowProps) {
  return (
    <TableRow
      item={client}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div>
          <span className="font-medium text-gray-800 block">
            {client.firstname} {client.lastname}
          </span>
          <span className="text-xs text-gray-500">
            {client.email}
          </span>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className="text-gray-600 text-sm">
          {client.phone}
        </span>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <span className="text-gray-500 text-xs">
          {new Date(client.created_at).toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })}
        </span>
      </td>
    </TableRow>
  );
}